import { render, staticRenderFns } from "./EntryRating.vue?vue&type=template&id=4fb12aee&scoped=true"
import script from "./EntryRating.vue?vue&type=script&lang=js"
export * from "./EntryRating.vue?vue&type=script&lang=js"
import style0 from "./EntryRating.vue?vue&type=style&index=0&id=4fb12aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb12aee",
  null
  
)

export default component.exports